module.exports = __webpack_public_path__ + "media/images/icon-close-black@3x-21b70edbca8244fd5444b47cbdd4727a.png";